import { createLazyComponent } from '@muse-web/router'

export const AsyncEditCollectionAudioDialogContainer = createLazyComponent(
    () =>
        import(
            /* webpackChunkName: 'dialog-edit-collection-audio' */ './EditCollectionAudioDialogContainer'
        ),
    'EditCollectionAudioDialogContainer',
)
